import { render, staticRenderFns } from "./LendifyContract.vue?vue&type=template&id=32dc290a&"
import script from "./LendifyContract.vue?vue&type=script&lang=js&"
export * from "./LendifyContract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports